import { isImage, isVideo } from '@unimpaired/utils'
import { motion } from 'framer-motion'
import React, { ComponentProps, forwardRef, Ref } from 'react'
import { Image } from './Image'
import { Video } from './Video'

type MediaProps = {
  src: string
  alt: string
  ratio?: '1:1' | '16:9' | '9:16' | '5:4' | '4:5'
  className?: string
  placeholderClassName?: string
  blur?: boolean
  overlay?: boolean
  children?: React.ReactNode
} & ComponentProps<typeof motion.img> &
  React.VideoHTMLAttributes<HTMLVideoElement>

export const Media = forwardRef(
  (
    { src, ratio, ...props }: MediaProps,
    ref: Ref<HTMLImageElement | HTMLVideoElement>,
  ) => {
    return (
      <div className={props.className}>
        {!isImage(src) && !isVideo(src) && props.children}
        {isImage(src) && (
          <Image
            src={src}
            aspectRatio={ratio}
            ref={ref as Ref<HTMLImageElement>}
            {...props}
          />
        )}
        {isVideo(src) && (
          <Video
            aspectRatio={ratio}
            src={src}
            ref={ref as Ref<HTMLVideoElement>}
            {...props}
          />
        )}
      </div>
    )
  },
)
